<template>
  <section class="article-cover" :class="article.coverImage ? 'article-cover--wide' : ''">
    <!-- Article title -->
    <h1>{{ article.title }}</h1>
    <!-- Article byline -->
    <article-byline
      :authors="article.authors"
      :created-at="article.createdAt"
      :last-updated-at="article.lastUpdatedAt"
    />
    <!-- Article cover image should be loaded ASAP,
         so no need to add loading="lazy" -->
    <article-cover-img
      v-if="article.coverImage"
      :alt="article.coverImageAlt || article.title"
      :src="article.coverImage"
    />
  </section>
</template>

<script>
import ArticleByline from './articleContent/articleByline'
import ArticleCoverImage from './articleContent/articleCoverImage'

export default {
  components: {
    'article-byline': ArticleByline,
    'article-cover-img': ArticleCoverImage,
  },
  props: {
    /**
     * Article data
     */
    article: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style lang="postcss" scoped>
@screen mobile {
  .article-cover {
    & .article-byline {
      font-size: 16px;
    }
  }
}

@screen desktop {
  .article-cover {
    & .article-byline {
      font-size: 18px;
    }
  }
}
</style>
